export const TEXT_NODE = 'textNode';
